import ReactDOM from "react-dom/client";
import App from "./App";
import { UserContextProvider } from "./store/userContext";

import * as Sentry from "@sentry/react";

import "./fonts/index.css";
import "./index.css";

Sentry.init({
  dsn: "https://9126374a0ad4bf711ac89c1cab392553@o4509078567780352.ingest.de.sentry.io/4509256143798352",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});



const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <UserContextProvider>
    <App />
  </UserContextProvider>
);
